var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-action mx-2 d-flex",class:{disabled: _vm.disabled}},[_c('fa-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }